import { type ReactNode } from 'react';

import { cn } from '@/lib/utils';

import { findRememberedAppMention } from './app-mention-memory';
import {
  MentionChipContent,
  mentionChipClassName,
  mentionChipTitle,
} from './mention-chip';

export const AppMentionChip = ({
  name,
  children,
}: {
  name: string;
  children: ReactNode;
}) => {
  const app = findRememberedAppMention(name);
  if (!app) return <span>{children}</span>;

  const mention = {
    id: `app:${app.name}`,
    kind: 'app',
    name: app.name,
    iconUrl: app.iconUrl,
    detail: null,
  };

  return (
    <span
      className={cn(mentionChipClassName(), 'not-prose select-text')}
      title={mentionChipTitle(mention)}
    >
      <MentionChipContent mention={mention} />
    </span>
  );
};
